import {
  Activity,
  ArrowUpDown,
  BarChart3,
  LayoutDashboard,
  CircleDollarSign,
} from 'lucide-react';

const COVER = '/images/Divers/Product_Cover/TEST_IA';

/** Roadmap items shown on Home — ids match newsletter interests. */
export const COMING_SOON_ITEMS = [
  {
    id: 'footprint',
    icon: Activity,
    image: '/images/Footprint/AlturionfootprintPro1.png',
  },
  {
    id: 'cumulative-delta',
    icon: ArrowUpDown,
    image: `${COVER}/alturion-cumulative-delta-pro.png`,
  },
  {
    id: 'delta-profile',
    icon: BarChart3,
    image: '/images/DeltaProfile/AlturionDeltaProfile1.webp',
  },
  {
    id: 'big-trades',
    icon: CircleDollarSign,
    image: '/images/BigTrades/AlturionBigTrade1.webp',
  },
  {
    id: 'dashboard',
    icon: LayoutDashboard,
    image: '/images/Dashboard/AlturionDashboard1.png',
  },
];

/** Slugs produit pas encore en vente : absents du catalogue /indicators. */
export const UNLISTED_PRODUCT_SLUGS = new Set([
  ...COMING_SOON_ITEMS.map((item) => item.id).filter((id) => id !== 'dashboard'),
  'account-locker',
]);
